import React from 'react'
import { IonList } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import PulsaraListItem from './PulsaraListItem.component'
import './PulsaraList.component.css'
import { useDispatch, useSelector } from 'react-redux'
import { getPulsaraSelector } from '../../selectors'
import { fetchPulsaraDetails } from '../../store/pulsara.actions'
import { IPulsaraRecord } from '../../store/pulsara.types'

const PulsaraList: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const pulsaraState = useSelector(getPulsaraSelector)
  const { pulsaraRecords, loading } = pulsaraState

  if (!loading && pulsaraRecords.length === 0) {
    return (
      <div className='pulsara-list-empty'>
        <p>{t('pulsara.NoResultsFound')}</p>
      </div>
    )
  }

  const onItemClick = (id: string | number) => {
    dispatch(fetchPulsaraDetails(id))
  }

  return (
    <IonList className='pulsara-list'>
      {pulsaraRecords.map((item: IPulsaraRecord) => (
        <PulsaraListItem key={item.id} item={item} onItemClick={(id) => onItemClick(id)} />
      ))}
    </IonList>
  )
}

export default PulsaraList
